import {Injectable, signal} from '@angular/core';
import {FilesAccordionState} from "../types/multi-type-files-viewer.types";

@Injectable({
  providedIn: 'root'
})
export class FilesAccordionStateService {
  private _panelsState = signal<Array<FilesAccordionState>>([]);
  public panelsState = this._panelsState.asReadonly();

  public togglePanel({ isOpen, key }: FilesAccordionState) {
    this._panelsState.update(current => {
      const existingIndex = current.findIndex(p => p.key === key);
      const newState = isOpen ?? !current.find(p => p.key === key)?.isOpen ?? false;

      if (existingIndex >= 0) {
        const updated = [...current];
        updated[existingIndex] = { key, isOpen: newState };
        return updated;
      }

      return [...current, { key, isOpen: newState }];
    });
  }

  public resetPanels() {
    this._panelsState.set([]);
  }
}
